import { FC, ReactNode } from 'react'
import { useField } from 'formik'

import { Option, Select, useSEOCountriesJSON } from '@pepper/ui'

import s from './LanguageSelector.module.css'

type Props = {
  name: string
  title?: string | ReactNode
  defaultValue?: string
}

const LanguageSelector: FC<Props> = ({ name, title, defaultValue }) => {
  const [field, _, helper] = useField(name)
  // Making it backward compatible till Mon, 23 Oct
  const { data: countries } = useSEOCountriesJSON()

  const languageOptions = [
    {
      value: 'US_English',
      label: 'American English (US English)',
      icon: countries?.us.flag,
    },
    {
      value: 'UK_English',
      label: 'British English (UK English)',
      icon: countries?.gb?.flag,
    },
  ]

  return (
    <div className={s.wrapper}>
      {title && <div className={s.title}>{title}</div>}
      <Select
        bordered={true}
        value={field.value}
        defaultValue={defaultValue}
        dropdownMatchSelectWidth={true}
        onSelect={value => helper.setValue(value)}
        className={s.languageField}
        placeholder="Choose your project language"
      >
        {languageOptions.map(languageOption => (
          <Option key={languageOption.value} value={languageOption.value}>
            <div className={s.optionWrapper}>
              <div className={s.container}>
                <img
                  src={languageOption.icon}
                  alt={languageOption.label}
                  width={20}
                  height={16}
                />
              </div>
              <div>{languageOption.label}</div>
            </div>
          </Option>
        ))}
      </Select>
    </div>
  )
}

export default LanguageSelector
